// Suporte a CNPJ alfanumérico (Receita Federal): 12 primeiros caracteres
// alfanuméricos (0-9, A-Z) + 2 dígitos verificadores numéricos. O CNPJ numérico
// antigo é um subconjunto (continua válido). CPF permanece só numérico.

const WEIGHTS_DV1 = [5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2];
const WEIGHTS_DV2 = [6, 5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2];

// Valor do caractere no cálculo do DV: ASCII menos 48 ('0'→0…'9'→9, 'A'→17…'Z'→42).
const charValue = (c) => c.charCodeAt(0) - 48;

const computeDv = (base, weights) => {
  let sum = 0;
  for (let i = 0; i < base.length; i += 1) {
    sum += charValue(base[i]) * weights[i];
  }
  const mod = sum % 11;
  return mod < 2 ? 0 : 11 - mod;
};

// Remove tudo que não for [0-9A-Z], letras em maiúsculo. Mantém letras (CNPJ alfanumérico).
export const sanitizeCnpj = (value) =>
  (value || '').toString().toUpperCase().replace(/[^0-9A-Z]/g, '');

// Formata CPF ou CNPJ (dual, por conteúdo). Sem letras e ≤11 → CPF; senão → CNPJ.
export const formatCpfCnpj = (value) => {
  const clean = sanitizeCnpj(value);
  const hasLetter = /[A-Z]/.test(clean);

  if (!hasLetter && clean.length <= 11) {
    const cpf = clean.slice(0, 11);
    return cpf
      .replace(/^(\d{3})(\d)/, '$1.$2')
      .replace(/^(\d{3})\.(\d{3})(\d)/, '$1.$2.$3')
      .replace(/\.(\d{3})(\d)/, '.$1-$2');
  }

  const base = clean.slice(0, 12);
  const dv = clean.slice(12).replace(/[^0-9]/g, '').slice(0, 2);
  const full = base + dv;

  let out = full.slice(0, 2);
  if (full.length > 2) out += '.' + full.slice(2, 5);
  if (full.length > 5) out += '.' + full.slice(5, 8);
  if (full.length > 8) out += '/' + full.slice(8, 12);
  if (full.length > 12) out += '-' + full.slice(12, 14);
  return out;
};

// Valida o dígito verificador do CNPJ (numérico ou alfanumérico). Só valida CNPJ (14).
export const isValidCnpj = (value) => {
  const clean = sanitizeCnpj(value);
  if (clean.length !== 14) return false;
  if (!/^[0-9]{2}$/.test(clean.slice(12))) return false;
  if (new Set(clean).size === 1) return false;

  const base = clean.slice(0, 12);
  const dv1 = computeDv(base, WEIGHTS_DV1);
  const dv2 = computeDv(base + String(dv1), WEIGHTS_DV2);
  return clean === base + String(dv1) + String(dv2);
};
